import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faMapMarker, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'particles.js'

Vue.config.productionTip = false

library.add(faEnvelope)
library.add(faMapMarker)
library.add(faPhone)
library.add(faLinkedin)
library.add(faLinkedinIn)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import router from './router'
import App from './App.vue'
new Vue({
  router,
  render: (h) => {
    return h(App);
  },
}).$mount('#app')

if (window.particlesJS) {
  window.particlesJS.load('particles', 'particles.json', function () {})
}
